import moment from "moment";
import { useSearchParams } from "react-router-dom";
import {
  EnumUpdatePriceType,
  EnumUpdateRemaindStatus
} from "../../../../../../server/routes/logUpdated/price/types";
import { EnumMarketplace } from "../../../../../../server/routes/marketplace/types";
import statuses from "../../statuses";
import { TContext } from "../types";

const useExtractFilter = () => {
  const [searchParams] = useSearchParams();
  const filter: TContext["filter"]["value"] = {
    fromDate: moment(),
    toDate: moment(),
  };
  //@ts-ignore
  (Array.from(searchParams.keys()) as string[])
    .filter((key) => key.indexOf("filter.") === 0)
    .forEach((field) => {
      const realField: string | keyof TContext["filter"]["value"] =
        field.replace("filter.", "");
      const value = searchParams.get(field) ?? undefined;
      switch (realField) {
        case "fromDate":
        case "toDate":
          filter[realField] = value ? moment(value) : moment();
          break;
        case "productId":
        case "productArticle":
          filter[realField] = value;
          break;
        case "clientFF":
          filter[realField] = value ? +value : undefined;
          break;
        case "marketplace":
          filter[realField] = value as EnumMarketplace;
          break;
        case "haveError":
          filter[realField] =
            value === "true" ? true : value === "false" ? false : undefined;
          break;
        case "type":
          switch (value) {
            case EnumUpdatePriceType.DISCOUNT:
            case EnumUpdatePriceType.PRICES:
              filter[realField] = value;
              break;
          }
          break;
        case "status":
          filter[realField] =
            value && Object.keys(statuses).indexOf(value) === -1
              ? undefined
              : (value as EnumUpdateRemaindStatus);
          break;
      }
    });
  return filter;
};

export default useExtractFilter;
